<template>
  <b-dropdown
    v-if="bankReceipt.attachments.length"
    :id="`attachment-${bankReceipt.id}`"
    :size="size"
    dropright
    right
    no-caret
    variant="flat-info"
    toggle-class="btn-icon rounded-circle"
  >
    <template v-slot:button-content>
      <feather-icon
        icon="PaperclipIcon"
      />
    </template>
    <template v-for="(attachment, key) in bankReceipt.attachments">
      <b-dropdown-item
        :key="key"
        :href="attachment.url"
        target="_blank"
        class="font-weight-bold btn-hover-transparent-primary"
      >
        <span class="direction-rtl">{{ attachment.name }}</span>
      </b-dropdown-item>
    </template>
    <b-tooltip :target="`attachment-${bankReceipt.id}`">
      {{ $t('Attachments') }}
    </b-tooltip>
  </b-dropdown>
</template>

<script>
import { BDropdown, BDropdownItem, BTooltip } from 'bootstrap-vue'

export default {
  name: 'BankReceiptsAttachmentsDropdown',
  components: {
    BDropdown,
    BDropdownItem,
    BTooltip,
  },
  props: {
    bankReceipt: {
      type: Object,
      default: () => {
      },
    },
    size: {
      type: String,
      default: () => 'sm',
    },
  },
}
</script>

<style scoped>

</style>
